module.exports = __webpack_public_path__ + "static/media/return.b61f834f.svg";